module.exports = __webpack_public_path__ + "static/backdrop_1-f8a5408f6ea2c6ffb9e85e7927512a08.png";